import { getLookupHostname, normalizeDomain } from "../utils/routing/hostUtils";

export const RCCG_CHAPEL_OF_MERCY_ORG_SLUG =
  "the-redeemed-christian-church-of-god-chapel-of-mercy-00405731";

const STATIC_CUSTOM_DOMAIN_MAPPINGS = {
  "rccgcm.org": {
    domain: "rccgcm.org",
    canonicalHost: "rccgcm.org",
    orgSlug: RCCG_CHAPEL_OF_MERCY_ORG_SLUG,
    orgId: RCCG_CHAPEL_OF_MERCY_ORG_SLUG,
    status: "active",
    verified: true,
    source: "static",
  },
};

// Inverse of the domain -> org map: resolve an organization's canonical public
// custom domain from its slug or id. Returns the verified, active custom domain
// (e.g. "rccgcm.org") or "" when the organization has none. Pure and
// template-agnostic — it matches on whatever orgs are configured, with no
// church-specific (or any vertical-specific) behavior. The `mappings` arg is
// injectable for testing; production callers use the static config.
export function resolveOrgCustomDomainFromMappings(
  orgIdentifier,
  mappings = STATIC_CUSTOM_DOMAIN_MAPPINGS,
) {
  const id = String(orgIdentifier || "").trim();
  if (!id) return "";
  for (const mapping of Object.values(mappings || {})) {
    if (!mapping) continue;
    if (mapping.status && mapping.status !== "active") continue;
    if (mapping.verified === false) continue;
    if (mapping.orgSlug === id || mapping.orgId === id) {
      return normalizeDomain(mapping.canonicalHost || mapping.domain || "");
    }
  }
  return "";
}

export function getOrgCustomDomain(orgIdentifier) {
  return resolveOrgCustomDomainFromMappings(orgIdentifier);
}

export function getStaticCustomDomainMapping(domain) {
  const normalizedDomain = normalizeDomain(domain);
  const lookupHostname = getLookupHostname(normalizedDomain);
  if (!lookupHostname) return null;

  const mapping = STATIC_CUSTOM_DOMAIN_MAPPINGS[lookupHostname];
  if (!mapping?.orgSlug) return null;

  return {
    id: lookupHostname,
    ...mapping,
    domain: normalizeDomain(mapping.domain || lookupHostname),
    canonicalHost: normalizeDomain(mapping.canonicalHost || lookupHostname),
    orgSlug: String(mapping.orgSlug || "").trim(),
  };
}

